import { render, staticRenderFns } from "./AuditScoreResultsTableHeader.vue?vue&type=template&id=cafb0188&"
import script from "./AuditScoreResultsTableHeader.vue?vue&type=script&lang=ts&"
export * from "./AuditScoreResultsTableHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports